<template>
  <ul class="sidebar-menu">
    <li class="header" v-if="hasAdminPermission">Administration</li>
    <li class="treeview" v-if="hasPermission($store, 'SETUP')">
      <a href="#">
        <i class="fa fa-cog"></i>
        <span>Setup</span>
        <span class="pull-right">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu icon-fw">
        <li>
          <router-link :to="{ name: 'Admin - Data Options' }">
            <i class="is-icon">DO</i>
            Data Options
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Roles' }">
            <i class="fa fa-group"></i>
            Roles
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Users' }">
            <i class="fa fa-user"></i>
            Users
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - User Groups' }">
            <i class="is-icon">UG</i>
            User Groups
          </router-link>
        </li>
        <li v-if="isSystemOptionParameterEnabled('ENABLE_MULTIPLE_USER_BRANDS')">
          <router-link :to="{ name: 'Admin - Tariff Set' }">
            <i class="fa fa-hand-scissors-o"></i>
            Tariff Set
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Documents' }">
            <i class="fa fa-file-text-o"></i>
            Documents
          </router-link>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="hasPermission($store, 'PARTY')">
      <a href="#">
        <i class="fa fa-address-book"></i>
        <span>Parties</span>
        <span class="pull-right">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu icon-fw">
        <li>
          <router-link :to="{ name: 'Admin - Parties' }">
            <i class="is-icon">PY</i>
            Parties
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Party Groups' }">
            <i class="is-icon">PG</i>
            Party Groups
          </router-link>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="hasPermission($store, 'FINANCE')">
      <a href="#">
        <i class="fa fa-dollar"></i>
        <span>Financial</span>
        <span class="pull-right">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu icon-fw">
        <li>
          <router-link :to="{ name: 'Admin - Calculations' }">
            <i class="fa fa-calculator"></i>
            Calculations
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Currencies' }">
            <i class="fa fa-dollar"></i>
            Currencies
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Exchange Rates' }">
            <i class="fa fa-exchange"></i>
            Exchange Rates
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Exchange Rate Histories' }">
            <i class="fa fa-history"></i>
            Exchange Rate Histories
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Financial Codes' }">
            <i class="fa fa-money"></i>
            Financial Codes
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Financial Profiles' }">
            <i class="is-icon">FP</i>
            Financial Profiles
          </router-link>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="hasPermission($store, 'ROUTE')">
      <a href="#">
        <i class="fa fa-road"></i>
        <span>Routing</span>
        <span class="pull-right">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu icon-fw">
        <li>
          <router-link :to="{ name: 'Admin - Consolidation Points' }">
            <i class="is-icon">CP</i>
            Consolidation Points
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Countries' }">
            <i class="fa fa-globe"></i>
            Countries
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Job Types' }">
            <i class="is-icon">JT</i>
            Job Types
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Locations' }">
            <i class="fa fa-location-arrow"></i>
            Locations
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Point To Ports' }">
            <i class="is-icon">PtP</i>
            Point To Ports
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Port Areas' }">
            <i class="is-icon">PA</i>
            Port Areas
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Routing Rules' }">
            <i class="is-icon">RR</i>
            Routing Rules
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Spreadsheet Descriptors' }">
            <i class="fa fa-table"></i>
            Spreadsheet Descriptors
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Transit Miles' }">
            <i class="is-icon">TM</i>
            Transit Miles
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin - Vendor Zones' }">
            <i class="is-icon">VZ</i>
            Vendor Zones
          </router-link>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="hasPermission($store, 'TARIFF')">
      <a href="#">
        <i class="fa fa-ship"></i>
        <span>Tariff</span>
        <span class="pull-right">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu icon-fw">
        <li>
          <router-link :to="{ name: 'Admin - Tariffs' }">
            <i class="fa fa-plane"></i>
            <span>Tariffs</span>
          </router-link>
        </li>
        <li v-if="isSystemOptionParameterEnabled('ENABLE_ACCESSORIALS')">
          <router-link :to="{ name: 'Admin - Accessorials' }">
            <i class="fa fa-truck"></i>
            <span>Accessorials</span>
          </router-link>
        </li>
        <li v-if="isSystemOptionParameterEnabled('ENABLE_QUOTE_TAXES')">
          <router-link :to="{ name: 'Admin - Quote Taxes' }">
            <i class="fa fa-legal"></i>
            <span>GST-VAT</span>
          </router-link>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="hasPermission($store, 'RFP')">
      <a @click.stop="$router.push({ name: 'Admin - Request For Proposals' })">
        <i class="fa fa-handshake-o"></i>
        <span>RFPs</span>
      </a>
    </li>
    <li class="header">{{ getConst(locale, 'MENU_HOME') }}</li>
    <li class="pageLink">
      <router-link to="/"><i class="fa fa-desktop"></i>
        <span class="page">{{ getConst(locale, 'MENU_DASHBOARD') }}</span>
      </router-link>
    </li>
    <li class="header" v-if="hasPermission($store, 'REPORT')">Reports</li>
    <li class="pageLink" v-if="hasPermission($store, 'REPORT')">
      <router-link :to="{ name: 'Admin - Report search', query: { [btoa('search')]: btoa(JSON.stringify({category: 'REPORT'})) } }"><i class="fa fa-area-chart"></i>
        <span class="page">Reports</span>
      </router-link>
    </li>
    <li class="header" v-if="hasPermission($store, 'QUOTE')">{{ getConst(locale, 'MENU_QUOTES') }}</li>
    <li class="pageLink" v-if="hasPermission($store, 'QUOTE')">
      <router-link :to="{ name: 'Add a new Quote' }"><i class="fa fa-plus-square"></i>
        <span class="page">{{ getConst(locale, 'ADD_NEW') }}</span>
      </router-link>
    </li>
    <li class="pageLink" v-if="hasPermission($store, 'QUOTE')">
      <router-link :to="{ name: 'Quote Batch Upload' }"><i class="fa fa-upload"></i>
        <span class="page">Batch Upload</span>
      </router-link>
    </li>
    <li class="pageLink" v-if="hasPermission($store, 'QUOTE')">
      <a @click.prevent="searchJobs">
        <i class="fa fa-search"></i>
        <span class="page">Search</span>
      </a>
    </li>
    <li class="header" v-if="hasPermission($store, 'TARIFF')">Tariff Builder</li>
    <li class="pageLink" v-if="hasPermission($store, 'TARIFF')">
      <router-link :to="{ name: 'RateAssist' }"><i class="fa fa-sliders"></i>
        <span class="page">Tariff Builder - Add New</span>
      </router-link>
    </li>
    <li class="header" v-if="hasPermission($store, 'TARIFF')">Tariff Merger</li>
    <li class="pageLink" v-if="hasPermission($store, 'TARIFF')">
      <router-link :to="{ name: 'Merge Tariffs' }"><i class="fa fa-link"></i>
        <span class="page">Tariff Merger - Add New</span>
      </router-link>
    </li>
  </ul>
</template>
<script>
  import Permissions from '../mixins/Permissions'
  import HelperMixin from '../modules/admin/mixins/Helpers'
  import basei18n from '../mixins/base-i18n'
  export default {
    name: 'SidebarName',
    mixins: [basei18n, Permissions, HelperMixin],
    methods: {
      toggleMenu (event) {
        // remove active from li
        var active = document.querySelector('li.pageLink.active')

        if (active) {
          active.classList.remove('active')
        }
        // window.$('li.pageLink.active').removeClass('active')
        // Add it to the item that was clicked
        event.toElement.parentElement.className = 'pageLink active'
      },
      searchJobs () {
        this.$router.push({ name: 'Admin - Job search', query: { [btoa('quick-search')]: btoa('%%') } })
      },
      btoa (str) {
        return window.btoa(str)
      }
    },
    computed: {
      locale () {
        return this.$store.getters['geolocation/country']
      },
      librarySections () {
        return this.$store.getters['library/sections']
      },
      hasAdminPermission () {
        const admins = ['SETUP', 'PARTY', 'FINANCE', 'ROUTE', 'TARIFF']
        return admins.filter(str => this.hasPermission(this.$store, str)).length > 0
      }
    }
  }
</script>
<style>
  /* override default */
  .sidebar-menu>li>a {
    padding: 12px 15px 12px 15px;
  }

  .sidebar-menu li.active>a>.fa-angle-left, .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
    animation-name: rotate;
    animation-duration: .2s;
    animation-fill-mode: forwards;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-90deg);
    }
  }
  .is-icon {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SidebarMenu.vue